"use strict";

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require("babel-runtime/helpers/extends");

var _extends4 = _interopRequireDefault(_extends3);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CodeMirror_1 = require("./CodeMirror/CodeMirror");
var Segment_1 = require("semantic-ui-react/dist/commonjs/elements/Segment/Segment");
var Label_1 = require("semantic-ui-react/dist/commonjs/elements/Label/Label");
require("codemirror/theme/ambiance.css");
var Icon_1 = require("semantic-ui-react/dist/commonjs/elements/Icon/Icon");
var ocamlLogo = require("../images/ocaml.svg");
var jsLogo = require("../images/js_logo.svg");
var Image_2 = require("semantic-ui-react/dist/commonjs/elements/Image/Image");
var Menu_2 = require("semantic-ui-react/dist/commonjs/collections/Menu/Menu");

var ReasonEditor = function (_React$Component) {
    (0, _inherits3.default)(ReasonEditor, _React$Component);

    function ReasonEditor() {
        (0, _classCallCheck3.default)(this, ReasonEditor);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ReasonEditor.__proto__ || Object.getPrototypeOf(ReasonEditor)).apply(this, arguments));

        _this.state = {
            showJs: false,
            showOcaml: false,
            showResult: true
        };
        _this.handleItemClick = function (e, _ref) {
            var name = _ref.name,
                active = _ref.active;
            return _this.setState(function (prevState) {
                return (0, _extends4.default)({}, prevState, (0, _defineProperty3.default)({}, name, !active));
            });
        };
        return _this;
    }

    (0, _createClass3.default)(ReasonEditor, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                reason = _props.reason,
                ocaml = _props.ocaml,
                js = _props.js,
                onUpdateCode = _props.onUpdateCode,
                options = _props.options,
                result = _props.result,
                title = _props.title;
            var _state = this.state,
                showResult = _state.showResult,
                showOcaml = _state.showOcaml,
                showJs = _state.showJs;

            if (typeof navigator === "undefined") {
                return React.createElement("code", null, reason);
            }
            var menuBlock = React.createElement(Menu_2.default, { icon: true, secondary: true, size: "mini" }, React.createElement(Menu_2.default.Item, { name: "showResult", active: showResult, onClick: this.handleItemClick }, React.createElement(Icon_1.default, { name: "terminal", size: "large", bordered: true })), React.createElement(Menu_2.default.Item, { name: "showOcaml", active: showOcaml, onClick: this.handleItemClick }, React.createElement(Image_2.default, { src: ocamlLogo, size: "mini" })), React.createElement(Menu_2.default.Item, { name: "showJs", active: showJs, onClick: this.handleItemClick }, React.createElement(Image_2.default, { src: jsLogo, size: "mini" })));
            var reasonBlock = reason ? React.createElement("div", { className: "reason-code" }, ReasonEditor.getEditor(reason, CodeMirror_1.Lang.Reason, options, onUpdateCode)) : React.createElement("code", null);
            var ocamlBlock = ocaml ? React.createElement("div", { className: "ocaml-code" }, ReasonEditor.getEditor(ocaml, CodeMirror_1.Lang.OCaml, (0, _extends4.default)({}, options), onUpdateCode)) : React.createElement("code", null);
            var jsBlock = js ? React.createElement("div", { className: "js-code" }, ReasonEditor.getEditor(ocaml, CodeMirror_1.Lang.Javascript, (0, _extends4.default)({}, options), onUpdateCode)) : React.createElement("code", null);
            var resultBlock = result ? React.createElement("div", { className: "code-results" }, React.createElement(Label_1.default, { color: "brown", ribbon: true, basic: true }, React.createElement(Icon_1.default, { fitted: true, name: "terminal", spaced: "right" }), " Result"), ReasonEditor.getEditor(result, CodeMirror_1.Lang.Output, (0, _extends4.default)({}, options))) : React.createElement("div", { className: "code-results" });
            return React.createElement(Segment_1.default.Group, null, React.createElement(Segment_1.default, null, menuBlock, reasonBlock, showResult && resultBlock, showOcaml && ocamlBlock, showJs && jsBlock));
        }
    }], [{
        key: "getEditor",
        value: function getEditor(code, lang) {
            var editorOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var onUpdateCode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (_) {
                return null;
            };

            if (typeof navigator !== "undefined") {
                return React.createElement(CodeMirror_1.default, { value: code, options: editorOptions, lang: lang, onEditorChange: onUpdateCode });
            }
            return React.createElement("code", null, code);
        }
    }]);
    return ReasonEditor;
}(React.Component);

exports.default = ReasonEditor;


// WEBPACK FOOTER //
// ./~/babel-loader/lib?{"presets":["babel-preset-env"],"plugins":["/home/travis/build/codekiln/gradus-reason/~/gatsby/dist/utils/babel-plugin-extract-graphql.js"]}!./~/ts-loader!./src/components/ReasonEditor.tsx